export const SET_ATHENTICATE = '@autenticacao/AUTHENTICATE';
export const SET_LOADING = '@autenticacao/SET_LOADING';
export const START_AUTHENTICATION = '@autenticacao/START_AUTHENTICATION';
export const SUCCEED_AUTHENTICATE = '@autenticacao/SUCCEED_AUTHENTICATE';
export const AUTHENTICATE_FAILED = '@autenticacao/AUTHENTICATE_FAILED';
export const SET_AUTH_VALUES = '@autenticacao/SET_AUTH_VALUES';
export const LOGOUT_SUCCEED = '@autenticacao/LOGOUT_SUCCEED';
